import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirObservations } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirObservations.STARTED]: handleActionStart,
  [fetchFhirObservations.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirObservations.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.observations,
  [clearCurrentPatient]: () => initialState,
});
